import * as fromDatatype from "../datatype-library/index";

interface GenericDocHdrJsonDatatypeInterface
  extends fromDatatype.JsonDatatypeInterface {
  userAgreementInfo?: {
    ip?: string;
    agreementDatetimeStamp: string;
  };
}

export interface bl_fi_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  server_doc_location: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  foreign_ccy: boolean;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  doc_desc: fromDatatype.TextDatatypeInterface;
  doc_remarks: fromDatatype.TextDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  doc_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_line_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gst_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_tax_num: fromDatatype.VarcharDatatypeInterface;
  gst_entity_type: fromDatatype.VarcharDatatypeInterface;
  gst_entity_contact_json: fromDatatype.JsonDatatypeInterface;
  display_entity_json: fromDatatype.JsonDatatypeInterface;
  delivery_entity_json: any;
  foreign_references_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: GenericDocHdrJsonDatatypeInterface;
  status_client: fromDatatype.StatusDataFieldInterface;
  status_server: fromDatatype.StatusDataFieldInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  credit_terms_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  amount_internal_settlement: fromDatatype.NumericDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  posting_inventory: fromDatatype.TextDatatypeInterface;
  posting_journal: fromDatatype.TextDatatypeInterface;
  posting_tax_gst: fromDatatype.TextDatatypeInterface;
  posting_tax_wht: fromDatatype.TextDatatypeInterface;
  posting_membership: fromDatatype.TextDatatypeInterface;
  posting_running_no: fromDatatype.TextDatatypeInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  arap_doc_open: fromDatatype.NumericDatatypeInterface;
  arap_contra: fromDatatype.NumericDatatypeInterface;
  arap_bal: fromDatatype.NumericDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  posting_cashbook: fromDatatype.TextDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  pickup_branch_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  reseller_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reseller_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
  delivery_date_expected:fromDatatype.TimestampTzDatatypeInterface
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  valid_days: fromDatatype.NumericDatatypeInterface;
  end_datetime: fromDatatype.TimestampTzDatatypeInterface;
  delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
  delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
  delivery_location_guid: fromDatatype.GuidDataFieldInterface;
  delivery_location_code: fromDatatype.VarcharDatatypeInterface;
  doc_internal_remarks: fromDatatype.VarcharDatatypeInterface;
  doc_external_remarks: fromDatatype.VarcharDatatypeInterface;
  landed_cost_amount: fromDatatype.NumericDatatypeInterface;
  apportion_type: fromDatatype.VarcharDatatypeInterface;
  custom_status: fromDatatype.VarcharDatatypeInterface;
  marketplace_status: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03_name: fromDatatype.VarcharDatatypeInterface;
  notification_email: fromDatatype.VarcharDatatypeInterface;
  notification_phone: fromDatatype.VarcharDatatypeInterface;
  client_salesman_code: fromDatatype.VarcharDatatypeInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_line_guid: fromDatatype.GuidDataFieldInterface;
  mkt_payment_status: fromDatatype.VarcharDatatypeInterface;
  bill_to: fromDatatype.TextDatatypeClass;
  mkt_order_no: fromDatatype.VarcharDatatypeInterface;
  marketplace_shipping_fee: fromDatatype.NumericDatatypeInterface;
  intercompany_execute: boolean;
  intercompany_target_doc_type: fromDatatype.VarcharDatatypeInterface;
  src_intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_settings_json: fromDatatype.JsonDatatypeInterface;
  print_count: fromDatatype.IntegerDatatypeInterface;
  print_status: fromDatatype.VarcharDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  svc_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  posting_budget: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_1: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_2: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_3: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_4: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_5: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  einvoice_self_billed: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  seller_order_alloc_queue: fromDatatype.VarcharDatatypeInterface;
  clone_source_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  packing_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_main_document_ref_irb_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
  billing_entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  skip_einvoice: boolean;
  delivery_driver_guid: fromDatatype.GuidDataFieldInterface;
  delivery_driver_code: fromDatatype.VarcharDatatypeInterface;
  vehicle_registration_no: fromDatatype.VarcharDatatypeInterface;
  vehicle_hdr_guid:fromDatatype.GuidDataFieldInterface;
  einvoice_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  entity_branch_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_main_document_ref_to_irb_lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_number: fromDatatype.VarcharDatatypeInterface;
  einvoice_billing_frequency: fromDatatype.VarcharDatatypeInterface;
  einvoice_billing_period_start: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_billing_period_end: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_submission_type_2: fromDatatype.VarcharDatatypeInterface;
  einvoice_submission_type_2_date_time: fromDatatype.TimestampTzDatatypeInterface;
  demographic_race: fromDatatype.VarcharDatatypeInterface;
  einvoice_shipping_entity_json: fromDatatype.JsonDatatypeInterface;
  einvoice_shipping_entity_guid: fromDatatype.GuidDataFieldInterface;
  trade_customs_ref_no: fromDatatype.VarcharDatatypeInterface;
  trade_incoterms: fromDatatype.TextDatatypeInterface;
  trade_agreement: fromDatatype.TextDatatypeInterface;
  trade_authorization_number: fromDatatype.VarcharDatatypeInterface;
  trade_custom_ref_no_2: fromDatatype.VarcharDatatypeInterface;
  trade_other_charges_desc: fromDatatype.TextDatatypeInterface;
  trade_country_of_origin: fromDatatype.VarcharDatatypeInterface;
  courier_service_provider_link: fromDatatype.VarcharDatatypeInterface;
  shipping_recipient_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  sales_entity_hdr_code: fromDatatype.VarcharDatatypeInterface;
  original_invoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  original_invoice_ref_no_column_name: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_details: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  date_finalized: fromDatatype.TimestampTzDatatypeInterface;
  date_discarded: fromDatatype.TimestampTzDatatypeInterface;
  date_voided: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_logic: fromDatatype.VarcharDatatypeInterface;
  doc_reference_date_txn: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_generic_doc_hdr_RowClass
  implements bl_fi_generic_doc_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  server_doc_location: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  foreign_ccy: boolean;
  base_doc_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  base_doc_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  doc_desc: fromDatatype.TextDatatypeInterface;
  doc_remarks: fromDatatype.TextDatatypeInterface;
  doc_reference_tax_num: fromDatatype.VarcharDatatypeInterface;
  doc_reference_tax_date: fromDatatype.TimestampTzDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  doc_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_line_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gst_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  gst_entity_tax_num: fromDatatype.VarcharDatatypeInterface;
  gst_entity_type: fromDatatype.VarcharDatatypeInterface;
  gst_entity_contact_json: fromDatatype.JsonDatatypeInterface;
  display_entity_json: fromDatatype.JsonDatatypeInterface;
  delivery_entity_json: any;
  foreign_references_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  status_json: fromDatatype.JsonDatatypeInterface;
  property_json: GenericDocHdrJsonDatatypeInterface;
  status_client: fromDatatype.StatusDataFieldInterface;
  status_server: fromDatatype.StatusDataFieldInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  credit_terms_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  code_branch: fromDatatype.VarcharDatatypeInterface;
  code_location: fromDatatype.VarcharDatatypeInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  posting_inventory: fromDatatype.TextDatatypeInterface;
  posting_journal: fromDatatype.TextDatatypeInterface;
  posting_tax_gst: fromDatatype.TextDatatypeInterface;
  posting_tax_wht: fromDatatype.TextDatatypeInterface;
  posting_membership: fromDatatype.TextDatatypeInterface;
  posting_running_no: fromDatatype.TextDatatypeInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  client_entity_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_date_01: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_02: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_03: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_04: fromDatatype.TimestampTzDatatypeInterface;
  client_doc_date_05: fromDatatype.TimestampTzDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  arap_doc_open: fromDatatype.NumericDatatypeInterface;
  arap_contra: fromDatatype.NumericDatatypeInterface;
  arap_bal: fromDatatype.NumericDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  posting_cashbook: fromDatatype.TextDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  pickup_branch_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  reseller_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reseller_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
  delivery_date_expected:fromDatatype.TimestampTzDatatypeInterface
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  valid_days: fromDatatype.NumericDatatypeInterface;
  end_datetime: fromDatatype.TimestampTzDatatypeInterface;
  delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
  delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
  delivery_location_guid: fromDatatype.GuidDataFieldInterface;
  delivery_location_code: fromDatatype.VarcharDatatypeInterface;
  doc_internal_remarks: fromDatatype.VarcharDatatypeInterface;
  doc_external_remarks: fromDatatype.VarcharDatatypeInterface;
  landed_cost_amount: fromDatatype.NumericDatatypeInterface;
  apportion_type: fromDatatype.VarcharDatatypeInterface;
  custom_status: fromDatatype.VarcharDatatypeInterface;
  marketplace_status: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03_name: fromDatatype.VarcharDatatypeInterface;
  notification_email: fromDatatype.VarcharDatatypeInterface;
  notification_phone: fromDatatype.VarcharDatatypeInterface;
  client_salesman_code: fromDatatype.VarcharDatatypeInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_line_guid: fromDatatype.GuidDataFieldInterface;
  mkt_payment_status: fromDatatype.VarcharDatatypeInterface;
  bill_to: fromDatatype.TextDatatypeClass;
  mkt_order_no: fromDatatype.VarcharDatatypeInterface;
  marketplace_shipping_fee: fromDatatype.NumericDatatypeInterface;
  intercompany_execute: boolean;
  intercompany_target_doc_type: fromDatatype.VarcharDatatypeInterface;
  src_intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_settings_json: fromDatatype.JsonDatatypeInterface;
  print_count: fromDatatype.IntegerDatatypeInterface;
  print_status: fromDatatype.VarcharDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  svc_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  amount_internal_settlement: fromDatatype.NumericDatatypeInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  posting_budget: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_1: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_2: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_3: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_4: fromDatatype.VarcharDatatypeInterface;
  xtn_doc_ref_5: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  einvoice_self_billed: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  seller_order_alloc_queue: fromDatatype.VarcharDatatypeInterface;
  clone_source_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  packing_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_main_document_ref_irb_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
  billing_entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  skip_einvoice: boolean;
  delivery_driver_guid: fromDatatype.GuidDataFieldInterface;
  delivery_driver_code: fromDatatype.VarcharDatatypeInterface;
  vehicle_registration_no: fromDatatype.VarcharDatatypeInterface;
  vehicle_hdr_guid:fromDatatype.GuidDataFieldInterface;
  einvoice_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  entity_branch_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_main_document_ref_to_irb_lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  einvoice_number: fromDatatype.VarcharDatatypeInterface;
  einvoice_billing_frequency: fromDatatype.VarcharDatatypeInterface;
  einvoice_billing_period_start: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_billing_period_end: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_submission_type_2: fromDatatype.VarcharDatatypeInterface;
  einvoice_submission_type_2_date_time: fromDatatype.TimestampTzDatatypeInterface;
  demographic_race: fromDatatype.VarcharDatatypeInterface;
  einvoice_shipping_entity_json: fromDatatype.JsonDatatypeInterface;
  einvoice_shipping_entity_guid: fromDatatype.GuidDataFieldInterface;
  trade_customs_ref_no: fromDatatype.VarcharDatatypeInterface;
  trade_incoterms: fromDatatype.TextDatatypeInterface;
  trade_agreement: fromDatatype.TextDatatypeInterface;
  trade_authorization_number: fromDatatype.VarcharDatatypeInterface;
  trade_custom_ref_no_2: fromDatatype.VarcharDatatypeInterface;
  trade_other_charges_desc: fromDatatype.TextDatatypeInterface;
  trade_country_of_origin: fromDatatype.VarcharDatatypeInterface;
  courier_service_provider_link: fromDatatype.VarcharDatatypeInterface;
  shipping_recipient_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  sales_entity_hdr_code: fromDatatype.VarcharDatatypeInterface;
  original_invoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  original_invoice_ref_no_column_name: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_details: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  date_finalized: fromDatatype.TimestampTzDatatypeInterface;
  date_discarded: fromDatatype.TimestampTzDatatypeInterface;
  date_voided: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_logic: fromDatatype.VarcharDatatypeInterface;
  doc_reference_date_txn: fromDatatype.TimestampTzDatatypeInterface;
}
